export const BAD_REQUEST = '400';
export const PROFILE_DETAIL_ERROR = '422';
export const INVALID_DISCOUNT_CODE = '412';
